import { useQuery } from '@tanstack/react-query';
import { initApis } from '../api/Api';
import { type IConfig } from '../types/config';
import { QUERY_KEYS } from './queryKeys';

type ConfigQueryType<Data, Error> = {
  isLoading: boolean;
  data: Data | undefined;
  error: Error | null;
};

export type useInitiateConfigQueryType = {
  config: ConfigQueryType<IConfig, Error>;
};

export const useConfigQuery = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.config],
    queryFn: async () => {
      try {
        return await initApis();
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    staleTime: 5 * 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
    retry: 3,
  });
};

export const useInitiateConfigQuery = (): useInitiateConfigQueryType => {
  const configQuery = useConfigQuery();

  return {
    config: {
      isLoading: configQuery.isLoading,
      data: configQuery.data,
      error: configQuery.error,
    },
  };
};
